<template>
    <div class="uk-margin-remove-top  "  >
        <div class="uk-padding uk-background-secondary" >
            <div class="uk-container uk-container-small">
                <div uk-grid>
                    <div class="uk-width-1-1@m">
                        <h5 class="uk-text-bold uk-text-center" style="color: gold;">
                          The Public’s Perception of the Operating Standards of the Jamaica Defence Force (JDF) Survey
                        </h5>
                    </div>
                    <div class="uk-width-1-1@m uk-text-center" style="margin-top: 15px">
                      <a href="https://www.surveymonkey.com/r/JPDPGFP" target="_blank"
                         class="uk-button uk-button-default uk-button-small uk-light">
                        Learn More
                        <span uk-icon="arrow-right"></span>
                      </a>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "latestNews"
    }
</script>

<style scoped>
    .podbar {
        bottom:0;
        /*position:fixed;
        z-index:150;*/
        _position:absolute;
        width: 100%;
    }
    a:hover {
      color: white;
    }
</style>
